import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/sales-price-kinds/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const salesPriceKind = {
  getAll: apiPathFunc(pathBase),
} as const;
